import { API_CONFIG } from '../config/api.config';
import { BaseApiClient } from './base-client';

class SpringBootApiClient extends BaseApiClient {
  protected baseUrl = API_CONFIG.SPRING_BOOT_BASE_URL;
}

export const springApiClient = new SpringBootApiClient();
